import { BareButton } from '@calendly/ui/components/bare-button';
import { PopupDropdownMenu } from '@calendly/ui/components/menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "cceceic";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const menuIsTabletUpCss = "m1hudrqu";
const menuCss = "m7h4k6o";
const Menu = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <PopupDropdownMenu ref={ref} {...props} className={classNames(menuCss, {
    [menuIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const wrapperIsTabletUpCss = "w1e0c1af";
const wrapperCss = "w11ik3zz";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const buttonIsPhoneCss = "bsx0hwv";
const buttonExpandedCss = "b1h4eubr";
const buttonCss = "b5zoc9w";
const Button = forwardRef((props, ref) => {
  const {
    expanded,
    ...restProps
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...restProps} className={classNames(buttonCss, {
    [buttonIsPhoneCss]: isPhone,
    [buttonExpandedCss]: expanded
  }, props.className)} />;
});
export { Container, Menu, Wrapper, Button };

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");